module.exports = __webpack_public_path__ + "static/media/icon-message.6dd536ef.svg";